module.exports = __webpack_public_path__ + "img/nightmare_before_christmas.4dadd565.jpg";